const Education =()=>{
    return (<section className="education-section py-3">
    <h3 className="text-uppercase resume-section-heading mb-4">
        Education
    </h3>
    <ul className="list-unstyled resume-education-list">
        <li className="mb-3">
            <div className="resume-degree font-weight-bold">
                BSc (Information Technology), Graduation Year 2021
            </div>
            <div className="resume-degree-org text-muted">
                Maseno University
            </div>
            <div className="resume-degree-time">
                <strong>First Class Honours</strong>
            </div>
            <div className="resume-degree-time text-muted">
                2016 - 2020
            </div>
        </li>
        <li>
            <div className="resume-degree font-weight-bold">
                Certificate in Windows Apps Development, Graduation Year
                2016
            </div>
            <div className="resume-degree-org text-muted">
                Emobilis Mobile Training Institute
            </div>
            <div className="resume-degree-time text-muted">May 2016</div>
            <br />
        </li>
        <li>
            <div className="resume-degree font-weight-bold">
                Certificate in Android Development, Graduation Year 2016
            </div>
            <div className="resume-degree-org text-muted">
                Emobilis Mobile Training Institute
            </div>
            <div className="resume-degree-time text-muted">
                Jan - April 2016
            </div>
            <br />
        </li>
        <li>
            <div className="resume-degree font-weight-bold">
                Kenya Certificate of Secondary Education (KCSE)
            </div>
            <div className="resume-degree-org text-muted">
                Kiambu High School
            </div>
            <div className="resume-degree-time text-muted">2012-2015</div>
            <br />
        </li>
        <li>
            <div className="resume-degree font-weight-bold">
                Kenya Certificate of Primary Education (KCPE)
            </div>
            <div className="resume-degree-org text-muted">
                Wakah Academy One
            </div>
            <div className="resume-degree-time text-muted">2002-2011</div>
        </li>
    </ul>
</section>);
}

export default Education;